import {AsyncAction} from '../asyncUtilsTypes';
import {UserBaseDTO} from 'hemwb-api';

export enum ModelViewersActions {
  FETCH = 'MODEL_VIEWERS/FETCH',
}

export type ModelViewersAction = AsyncAction<ModelViewersActions.FETCH, UserBaseDTO[], [string]>;
